export default __webpack_public_path__ + "static/media/DSC_7671.33b63495.jpg";